import Icon from '../components/Icon.vue'

Icon.register({"i-cursor":{"width":1024,"height":1792,"paths":[{"d":"M832 128q-320 0-320 224v416h128v128h-128v544q0 224 320 224h64v128h-64q-272 0-384-146-112 146-384 146h-64v-128h64q320 0 320-224v-544h-128v-128h128v-416q0-224-320-224h-64v-128h64q272 0 384 146 112-146 384-146h64v128h-64z"}]}})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/i-cursor.js
// module id = JDk9
// module chunks = 0